/**
 * Minimum and maximum values for price impact ranges
 */
const PRICE_IMPACT_RANGES: Record<
  "FAIR" | "NORMAL" | "EXPENSIVE",
  {MIN: number; MAX: number}
> = {
  FAIR: {
    MIN: 0,
    MAX: 1
  },
  NORMAL: {
    MIN: 1,
    MAX: 5
  },
  EXPENSIVE: {
    MIN: 5,
    MAX: Infinity
  }
};

export {PRICE_IMPACT_RANGES};
